module.exports = __webpack_public_path__ + "static/media/AboutUs-Hero.f606d52f.svg";